import { render, staticRenderFns } from "./StockVendorShow.vue?vue&type=template&id=8b7fb1d8"
import script from "./StockVendorShow.vue?vue&type=script&lang=js"
export * from "./StockVendorShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports